<template>
  <div class="OtherSalaries" >
    <section id='form-section-banner' :style="{ backgroundImage: 'url(' + require('@/assets/images/camera_banner.jpg') + ')' }">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 v-if="typeSalarie == 'PERM'" class="form-section-banner-title">
              Salariés permanents
            </h1>
            <h1 v-if="typeSalarie == 'INTER'" class="form-section-banner-title">
              Intermittents
            </h1>
            <h1 v-if="typeSalarie == 'PIG'" class="form-section-banner-title">
              Journalistes pigistes
            </h1>
          </div>
        </div>
      </div>
    </section>
      <div class="container">
        <div class="form_div">
          <div class="form_content">
              <h2>
                Autres services partagés
              </h2>
              <p>
                Vous trouverez sur cette page l'ensemble des mesures mises en place pour vous soutenir.<br>
                <em>Cliquez sur les mesures pour accéder à leur contenu</em>
              </p>

              <h3>
                Formation
              </h3>

              <div class="row mt-2">
                <div class="col-12">
                  <ol class="gradient-list">
                    <li v-if="typeSalarie == 'INTER'">
                      Intermittents du spectacle :
                      <a class="aide-link" href='https://www.afdas.com/particuliers/services/choisir/trouver-une-formation-ou-un-organisme-de-formation' target="_blank">
                        <strong>trouver votre formation</strong>
                      </a>
                    </li>
                    <li v-if="typeSalarie == 'PIG'">
                      Journaliste pigiste de la presse :
                      <a class="aide-link" href='https://www.afdas.com/particuliers/services/financement/pigistes/offre-cle-en-main-pigistes-1' target="_blank">
                        <strong>trouver votre formation</strong>
                      </a>
                    </li>
                    <li><a class="aide-link" href='https://www.afdas.com/offres-formation-distanciel-entreprises-particuliers#des-offres-de-formation-a-distance-pour-les-particuliers-(intermittents-du-spectacle,-artistes-auteurs)' target="_blank">
                      <strong>Une sélection d'offres</strong>
                    </a> clés en main 100% à distance
                    </li>
                  </ol>
                </div>
              </div>


              <h3>
                Santé au travail
              </h3>

              <div class="row mt-2">
                <div class="col-12">
                  <ol class="gradient-list">
                    <li v-if="typeSalarie == 'INTER' || typeSalarie == 'PERM'">
                      <a class="aide-link" href='http://www.cmb-sante.fr/suivi-des-salari%C3%A9s-salari%C3%A9s_152_569.html' target="_blank">
                        <strong>Suivi en santé au travail</strong>
                      </a> des salariés intermittents du spectacle (France entière) et des salariés permanents (Ile-de-France)
                    </li>
                    <li v-if="typeSalarie == 'INTER'">
                      <a class="aide-link" href='https://convocations-idf.cmb-sante.fr/Index.aspx' target="_blank">
                        Mise à disposition de <strong>l'application CONVOWEB</strong>
                      </a> permettant la prise de rendez-vous et l'accès au duplicata de l'attestation de visite
                    </li>
                    <li v-if="typeSalarie == 'INTER'">
                      <a class="aide-link" href='http://www.cmb-sante.fr/contact.php' target="_blank">
                        <strong>Téléconsultations</strong>
                      </a> en direction des intermittents isolés
                    </li>
                    <li>
                      <a class="aide-link" href='http://www.cmb-sante.fr/_upload/ressources/06espace_pratique/062prevention_pratique/guide-du-cirque-2019-partie1.pdf' target="_blank">
                        Mise à disposition de <strong>guides spécifiques</strong>
                      </a> : troubles musculo-squelettiques des artistes, guide cirque, harcèlement sexuel et agissements sexistes
                    </li>
                    <li>
                      <a class="aide-link" href="mailto:covid19-ids@cmb.asso.fr?subject=Cellules d'accompagnement CMB" target="_blank">
                        <strong>Cellules ad hoc</strong> créées en lien avec les évènements du secteur
                      </a> : écoute psycho-sociale, groupe Covid
                    </li>
                  </ol>
                </div>
              </div>

              <h3>
                Santé et prévention
              </h3>

              <div class="row mt-2">
                <div class="col-12">
                  <ol class="gradient-list">
                    <li>
                      <a class="aide-link" href='https://www.pole-sante-bergere.org/accueil/consultations-et-rendez-vous.html' target="_blank">
                        Soins de santé au <strong>Pôle Santé Bergère</strong>
                      </a>
                    </li>
                    <li v-if="typeSalarie == 'INTER' || typeSalarie == 'PIG'">
                      <a class="aide-link" href='https://www.audiens.org/accueil/formulaires/formulaire-pre-inscription-bilan-professionnel.html?utm_campaign=Emailing+cibl%c3%a9_+Relance_CliqueursNLsept_Pro%2b&utm_content=B%c3%a9n%c3%a9ficiez+d%e2%80%99un+bilan+de+pr%c3%a9vention+sant%c3%a9+UNIQUE+!&utm_medium=Emailing+via+Message+Business&utm_source=Message+Business&utm_term=AUDIENS' target="_blank">
                        <strong>Bilan de prévention santé</strong>
                      </a> pour les intermittents et les journalistes pigistes
                    </li>
                    <li>
                      <a class="aide-link" href='https://www.audiens.org/solutions/offre-esante-medecin-direct.html' target="_blank">
                        <strong>Téléconsultation</strong>
                      </a> pour les assurés en santé
                    </li>
                    <li>
                      <a class="aide-link" href="https://www.audiens.org/actu/cellule-ecoute-psychologique-et-juridique.html" target="_blank">
                        Cellule d'écoute psychologique et juridique de lutte contre les <strong>violences sexuelles et sexistes / Consultation emprise</strong>
                      </a>

                    </li>
                  </ol>
                </div>
              </div>


              <h3>
                Accompagnement socio-professionnel
              </h3>

              <div class="row mt-2">
                <div class="col-12">
                  <ol class="gradient-list">
                    <li v-if="typeSalarie == 'INTER'">
                      <a class="aide-link" href='https://garde-enfant-fonpeps-audiens.org/' target="_blank">
                        Financement de la <strong>garde d'enfant</strong>
                      </a> pour les intermittents
                    </li>
                    <li v-if="typeSalarie == 'PERM'">
                      <a class="aide-link" href='https://www.audiens.org/solutions/accompagnement-salarie-retour-a-l-emploi.html?univers=p---votre-parcours-professionnel' target="_blank">
                        Accompagnement <strong>Retour à l'emploi</strong>
                      </a>
                    </li>
                    <li v-if="typeSalarie == 'PIG'">
                      <a class="aide-link" href='https://www.audiens.org/solutions/accompagnement-pigiste-retour-a-l-emploi.html?univers=p---votre-parcours-professionnel' target="_blank">
                        Accompagnement <strong>Retour à l'emploi</strong>
                      </a>
                    </li>
                    <li v-if="typeSalarie == 'INTER'">
                      <a class="aide-link" href='http://www.artistesettechniciensduspectacle.fr/' target="_blank">
                        Accompagnement du <strong>parcours professionnel fragilisé</strong>
                      </a> pour les intermittents
                    </li>
                    <li>
                      <a class="aide-link" href="http://www.cmb-sante.fr/maintien-en-emploi_espace-pratique_1233.html" target="_blank">
                        Plateforme Prévention
                      </a>
                      de la <strong>désinsertion professionnelle</strong>
                    </li>
                    <li v-if="typeSalarie == 'INTER'">
                      <a class="aide-link" href='http://missionh-spectacle.fr/' target="_blank">
                        Fragilité de santé, handicap et emploi
                      </a>
                    </li>
                    <li>
                      <a class="aide-link" href="https://www.audiens.org/solutions/accompagner-un-proche-en-situation-de-perte-d-autonomie-ou-de-handicap.html?univers=votre-famille" target="_blank">
                        Soutien aux salariés par ailleurs <strong>aidants familiaux</strong>
                      </a>
                    </li>
                  </ol>
                </div>
              </div>


              <h3>
                Anticipation et préparation retraite
              </h3>

              <div class="row mt-2">
                <div class="col-12">
                  <ol class="gradient-list">
                    <li>
                      <a class="aide-link" href="https://www.audiens.org/solutions/preparer-retraite.html?univers=p---votre-retraite&solution2=container-flydispositifs-preparation" target="_blank">
                        Sessions d'information collectives <strong>"Tout savoir sur la retraite"</strong>
                      </a>
                      les modalités techniques mais aussi le changement de vie
                    </li>
                    <li>
                      <a class="aide-link" href="https://www.audiens.org/solutions/comprendre-anticiper-retraite.html?univers=p---votre-retraite&solution2=container-flycomprendre-entretien-information-retraite" target="_blank">
                        <strong>Entretien Individuel Retraite</strong>
                      </a> : dates de départ possibles, estimation du montant de votre retraite, comment faire la demande, cumul emploi/retraite etc.
                    </li>
                  </ol>
                </div>
              </div>

              <b-button @click="goToCovidSalaries" size="lg" pill block variant="outline-primary">Accéder aux mesures spéciales COVID</b-button>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OtherSalaries',
  computed: {
    typeSalarie: {
      get () {
        return this.$store.state.characteristics.typeSalarie
      },
    },
  },
  methods: {
    goToCovidSalaries () {
      this.$router.push('/covid/salaries')
    },
  }
}
</script>

<style lang="scss">
/*** EXTEND ***/
/* box-shadow */
%boxshadow {
  box-shadow: 0.25rem 0.25rem 0.6rem rgba(0,0,0,0.05), 0 0.5rem 1.125rem rgba(75,0,0,0.05);
}

/*** STYLE ***/

*,
*:before,
*:after {
  box-sizing: border-box;
}

.aide-link {
  text-decoration: none;
}



ol.gradient-list {
  counter-reset: gradient-counter;
  list-style: none;
  margin: 1.75rem 0;
  padding-left: 1rem;
  > li {
    background: white;
    border-radius: 0 0.5rem 0.5rem 0.5rem;
    @extend %boxshadow;
    counter-increment: gradient-counter;
    margin-top: 1rem;
    min-height: 2rem;
    padding: 1rem 1rem 1rem 3rem;
    position: relative;
    &::before,
    &::after {
      background-color: #d6075b;
      content: '';
      height: 2rem;
      left: -0.5rem;
      overflow: hidden;
      position: absolute;
      top: -0.5rem;
      width: 2rem;
    }
    &::before {
      align-items: flex-end;
      @extend %boxshadow;
      content: counter(gradient-counter);
      color: #1d1f20;
      display: flex;
      font-weight: 800;
      color: white;
      justify-content: flex-end;
      padding: 0.23em 0.7em;
      z-index: 1;
    }

    + li {
      margin-top: 2rem;
    }
  }
}


</style>
